module.exports = __webpack_public_path__ + "rijksoverheidsanstext-italic_2_0.woff2?c8b3fbf09a9159f5c11c641c5cf17e3d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/rijksoverheidsanstext-italic_2_0.woff2
// module id = 545
// module chunks = 0